<template>
  <div class="min-h-screen bg-gray-100 p-6">
    <div class="max-w-5xl mx-auto bg-white p-6 rounded shadow">
      <!-- Header พร้อมปุ่ม Logout -->
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold">🎯 Admin Dashboard</h1>
        <button @click="logout" class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
          Logout
        </button>
      </div>

      <!-- Tabs -->
      <div class="flex border-b mb-4">
        <button
          v-for="tab in tabs"
          :key="tab"
          @click="currentTab = tab"
          :class="[
            'px-4 py-2 font-semibold',
            currentTab === tab
              ? 'border-b-2 border-blue-600 text-blue-600'
              : 'text-gray-600 hover:text-blue-500',
          ]"
        >
          {{ tab }}
        </button>
      </div>

      <!-- Tab Content -->
      <div v-if="currentTab === 'รายการรางวัล'">
        <RewardTable />
      </div>
      <div v-else-if="currentTab === 'หมวดหมู่รางวัล'">
        <CategoryTable />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CategoryTable from '../components/CategoryTable.vue';
import RewardTable from '../components/RewardTable.vue';

export default {
  name: 'AdminDashboardPage',
  components: {
    CategoryTable,
    RewardTable,
  },
  setup() {
    const router = useRouter();
    const tabs = ['รายการรางวัล', 'หมวดหมู่รางวัล'];
    const currentTab = ref(tabs[0]);

    const logout = () => {
      router.push('/dangnhap');
    };

    return { tabs, currentTab, logout };
  },
};
</script>
